export default "__VITE_ASSET__bd75c040__"